import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ContactUsService } from 'src/app/Services/contact-us.service';

@Component({
  selector: 'app-contact-body',
  templateUrl: './contact-body.component.html',
  styleUrls: ['./contact-body.component.scss']
})
export class ContactBodyComponent implements OnInit {
  contactForm: FormGroup;
  constructor(private toastr: ToastrService,
    private contact: ContactUsService, private formBuilder: FormBuilder,) { }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      name: [null, Validators.compose([Validators.required, Validators.minLength(3)])],
      email: [
        null,
        Validators.compose([Validators.email,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      ],
      phone: [
        null,
        Validators.compose([
          Validators.maxLength(10),
          Validators.minLength(10),
          Validators.pattern('[56789][0-9]{9}'),
        ]),
      ],
      message: [null, Validators.compose([Validators.required])],

    });
  }
  onSubmit(data) {
    data['email'] = btoa(data['email']);
    data['phone'] = btoa(data['phone']);
    this.contact.createContactRecord(data).subscribe(response => this.handleResponse(response));
  }

  handleResponse(data) {
    if (data['type'] == "Success") {
      this.toastr.success(data['message']);
    } else {
      this.toastr.error(data['message'])
    }
    this.ngOnInit();
  }

  checkPhoneNumber(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  isDotKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == 46) {
      return false;
    }
    return true;
  }
}
